export function printJson(...args) {
    args.forEach(arg => {});
}
export function printErrorJson(...args) {
    args.forEach(arg => console.error(JSON.stringify(arg, undefined, 4)));
}
